module.exports = __webpack_public_path__ + "img/th_Shot_Rock.69cd5d8e.jpg";